<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <user-form />
  </v-container>
</template>

<script>
import UserForm from './_Form'

export default {
  name: 'AdminUserEdit',
  components: {
    UserForm
  },
  data () {
    return {
      breadcrumbs: [
        { text: 'Adminユーザ', disabled: false, to: '/admin/users', exact: true },
        { text: 'Adminユーザ編集', disabled: true, to: '' },
      ],
    }
  },
  created() {
  },
  methods: {}
}
</script>

